module.exports = __webpack_public_path__ + "static/img/loading.2b39dc66.gif";